import Rates from './rates'

export default Rates